import colors from '@/theme/colors';
import { styled } from '@mui/system';
import { css, cx } from '@emotion/css';
import { darken } from '@mui/material/styles';
import { forwardRef } from 'react';
import { ButtonBase, ButtonBaseProps } from './ButtonBase';
import {
  ButtonPrimaryMediumStyles,
  ButtonPrimarySmallStyles,
  ButtonPrimaryLargeStyles,
} from './Buttons.styles';

export const ButtonOutline = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  (
    {
      children,
      className,
      background = 'transparent',
      fontColor = colors.jungle,
      ...rest
    }: ButtonBaseProps,
    ref
  ) => (
    <ButtonBase
      ref={ref}
      className={cx(
        className,
        css`
          &.MuiButton-root {
            background: ${background} !important;
            color: ${fontColor} !important;
            border-color: ${fontColor} !important;
          }
          &.MuiButton-root:hover {
            border-color: ${darken(fontColor, 0.2)} !important;
            background: ${background} !important;
            color: ${fontColor} !important;
          }
          &.MuiButton-root:focus {
            border-color: ${darken(fontColor, 0.4)} !important;
            background: ${background} !important;
            color: ${fontColor} !important;
          }
        `
      )}
      {...rest}
      variant="outlined"
    >
      {children}
    </ButtonBase>
  )
);

export const ButtonOutlineSmall = styled(ButtonOutline)(ButtonPrimarySmallStyles);
export const ButtonOutlineMedium = styled(ButtonOutline)(ButtonPrimaryMediumStyles);

export const ButtonOutlineLarge = styled(ButtonOutline)(ButtonPrimaryLargeStyles);
